import React from "react";
import styles from "./AboutUs.module.css";
import Background from "./Background";

export default function AboutUs() {
  return (
    <div className={styles.container}>
      <Background />
      <div className={styles.about_contained}>
        <p className={styles.about_heading}>ABOUT US</p>
        <div className={styles.about_a}>
          <div className={styles.image}></div>
          <div className={styles.info}>
            <p>
              SoulStrings is a vibrant initiative by Mood Indigo, dedicated to
              celebrating and promoting India's talented singer-songwriters.
              This platform is designed to showcase both emerging and
              established artists, fostering a community that values original
              music and heartfelt storytelling.
            </p>
            <p style={{ marginTop: "2%" }}>
              Aspiring singer-songwriters, regardless of experience, are invited
              to join this movement. Whether you're new to the craft or a
              seasoned artist, SoulStrings offers the perfect stage to share
              your music with an appreciative audience.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
